import { useState, useEffect, useMemo } from "react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SIZES = [25, 50, 100];

export function usePagination(items, testid = "pagination") {
  const [pageSize, setPageSize] = useState(25);
  const [page, setPage] = useState(1);
  const total = items.length;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => { if (page > pageCount) setPage(1); }, [pageCount, page]);

  const paged = useMemo(() => items.slice((page - 1) * pageSize, page * pageSize), [items, page, pageSize]);
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const controls = (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-border" data-testid={testid}>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span>Righe per pagina</span>
        <Select value={String(pageSize)} onValueChange={(v) => { setPageSize(Number(v)); setPage(1); }}>
          <SelectTrigger className="h-8 w-[76px]" data-testid={`${testid}-size`}><SelectValue /></SelectTrigger>
          <SelectContent>{SIZES.map((n) => <SelectItem key={n} value={String(n)}>{n}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        <span data-testid={`${testid}-info`}>{from}–{to} di {total}</span>
        <div className="flex items-center gap-1">
          <Button variant="outline" size="icon" className="h-8 w-8" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))} data-testid={`${testid}-prev`}><ChevronLeft className="h-4 w-4" /></Button>
          <span className="px-1 tabular-nums">{page}/{pageCount}</span>
          <Button variant="outline" size="icon" className="h-8 w-8" disabled={page >= pageCount} onClick={() => setPage((p) => Math.min(pageCount, p + 1))} data-testid={`${testid}-next`}><ChevronRight className="h-4 w-4" /></Button>
        </div>
      </div>
    </div>
  );

  return { paged, controls };
}
